const likeButtons = document.querySelectorAll("[data-like-button]");

function parseContext(button) {
    try {
        return JSON.parse(button.getAttribute("data-like-context") || "{}");
    } catch {
        return {};
    }
}

function setButtonState(button, state) {
    const count = Number(state.count || 0);
    const liked = Boolean(state.liked);
    const countElement = button.querySelector("[data-like-count]");
    const statusElement = button.querySelector("[data-like-status]");

    button.classList.toggle("has-count", count > 0);
    button.classList.toggle("is-liked", liked);
    button.classList.remove("is-pending");
    button.setAttribute("aria-pressed", liked ? "true" : "false");
    button.dataset.likeCount = String(count);
    button.dataset.likeLiked = liked ? "1" : "0";

    if (countElement) {
        countElement.textContent = count > 0 ? String(count) : "";
    }
    if (statusElement) {
        statusElement.textContent = liked ? "Bereits geliked" : "Gefällt mir";
    }
}

function syncTarget(target, state) {
    Array.from(document.querySelectorAll("[data-like-button]"))
        .filter((button) => button.getAttribute("data-like-target") === target)
        .forEach((button) => setButtonState(button, state));
}

async function hydrateLikes() {
    if (!likeButtons.length) {
        return;
    }

    const targets = Array.from(
        new Set(
            Array.from(likeButtons)
                .map((button) => button.getAttribute("data-like-target"))
                .filter(Boolean),
        ),
    );

    if (!targets.length) {
        return;
    }

    const url = new URL("/__likes/status", window.location.origin);
    url.searchParams.set("targets", targets.join(","));

    try {
        const response = await fetch(url, {
            credentials: "same-origin",
            headers: {
                Accept: "application/json",
            },
        });

        if (!response.ok) {
            return;
        }

        const data = await response.json();
        Object.entries(data.targets || {}).forEach(([target, state]) => {
            syncTarget(target, state);
        });
    } catch {
        return;
    }
}

function bindLikeButton(button) {
    button.addEventListener("click", async () => {
        if (button.classList.contains("is-pending") || button.dataset.likeLiked === "1") {
            return;
        }

        const target = button.getAttribute("data-like-target");
        if (!target) {
            return;
        }

        button.classList.add("is-pending");

        try {
            const response = await fetch("/__likes/like", {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    target,
                    context: parseContext(button),
                }),
            });

            if (!response.ok) {
                button.classList.remove("is-pending");
                return;
            }

            const data = await response.json();
            syncTarget(target, {
                count: data.count,
                liked: data.liked,
            });
        } catch {
            button.classList.remove("is-pending");
        }
    });
}

function initLikes() {
    if (!likeButtons.length) {
        return;
    }

    likeButtons.forEach(bindLikeButton);
    hydrateLikes();
}

export { initLikes };
